import { types } from 'mobx-state-tree';
import { AccountType } from 'utils/enumerations/accountType';

export const UserModel = types
  .model('UserModel', {
    name: types.string,
    organisationNumber: types.maybe(types.string),
    organisationName: types.maybe(types.string),
    socialSecurityNumber: types.maybe(types.string),
    phoneNumber: types.maybe(types.string),
    mobilePhoneNumber: types.string,
    email: types.string,
    address: types.string,
    zipCode: types.string,
    city: types.string
  })
  .views(self => ({
    get accountType() {
      if (self.organisationNumber) {
        return AccountType.Organisation;
      } else {
        return AccountType.Personal;
      }
    }
  }))
  .actions(self => ({
    setValues(changedValues) {
      for (let key in changedValues) {
        self[key] = changedValues[key];
      }
    }
  }));
